import Vue from 'vue';

export default {
  async get(filter) {
    return (await Vue.http.post('/api/bk/bets/list', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/bk.service.js